import connection from './connection';
import axios from 'axios';
import { CommonResponse, ForkLiftJobDTO, ForkLiftJobIdRequest, ForkLiftJobRequestDTO, ForkLiftJobStatusRequest, GetForkLiftJobResponseModel, JobIdRequest, updateJobQty } from '@gtpl/shared-models/warehouse-management';
import { PlantIdRequest } from '@gtpl/shared-models/masters';
import { PlantRequest } from '@gtpl/shared-models/raw-material-procurement';

export class ForkLiftJobService {
    URL = connection.DEPLOY_URL + '/fork-lift-jobs';

    async createForkLiftJob(forkLiftJobDTO: ForkLiftJobDTO): Promise<GetForkLiftJobResponseModel> {
        return await axios.post(this.URL + '/createForkLiftJob', forkLiftJobDTO)
            .then(res => {
                return res.data
            })
    }
    async updateForkLiftJobStatus(forkLiftJobStatusRequest: ForkLiftJobStatusRequest): Promise<boolean> {
        return await axios.post(this.URL + '/updateForkLiftJobStatus', forkLiftJobStatusRequest)
            .then(res => {
                return res.data
            })
    }
    async getForkliftJobCodes(forkLiftJobRequestDTO: ForkLiftJobRequestDTO): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getForkliftJobCodes', forkLiftJobRequestDTO)
            .then(res => {
                return res.data
            })
    }

    async getForkliftJobCodesForGrid(forkLiftJobRequestDTO: ForkLiftJobRequestDTO): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getForkliftJobCodesForGrid', forkLiftJobRequestDTO)
            .then(res => {
                return res.data
            })
    }
    async getSosAgainstJob(req: JobIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSosAgainstJob', req)
            .then(res => {
                return res.data
            })
    }
    async updateForkLiftJobQty(req: updateJobQty): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateForkLiftJobQty', req)
            .then(res => {
                return res.data
            })
    }
    async getAllStockTranserDcData(req: PlantRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllStockTranserDcData', req)
            .then(res => {
                return res.data
            })
    }
    async getAllStockTranserMrnData(req: PlantRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllStockTranserMrnData', req)
            .then(res => {
                return res.data
            })
    }
    async getStockTranserItemsData(req: JobIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getStockTranserItemsData', req)
            .then(res => {
                return res.data
            })
    }
    async getAllForkLiftItemsByJobId(req: ForkLiftJobIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllForkLiftItemsByJobId', req)
            .then(res => {
                return res.data
            })
    }
    
}
